;(function () {
  'use strict'

  angular
    .module('contrast.libraries')
    .factory(
      'LibrariesFilterRequestBuilderService',
      LibrariesFilterRequestBuilderService
    )

  function LibrariesFilterRequestBuilder($scope, params) {
    if (!angular.isObject(params)) {
      params = {}
    }
    this.$scope = $scope
    this.selectedSubFilters = params.selectedSubFilters
  }

  /**
   * @description Builds a libraries tagging filter request object.
   * @param {string} [libraryHash] - library hash
   * @returns {object}
   */
  LibrariesFilterRequestBuilder.prototype.build = function (extra) {
    var $scope = this.$scope

    var request = angular.extend({}, extra)

    if (
      !request.libraryHashes ||
      (request.libraryHashes && !request.libraryHashes.length)
    ) {
      request.libraryHashes = $scope.selectedLibraries.map(function (lib) {
        return lib.hash
      })
    }

    request = angular.extend(request, this.selectedSubFilters)

    if (angular.isFunction($scope.searchKeywords)) {
      request.q = $scope.searchKeywords()
    }

    if ($scope.selectedQuickFilter) {
      request.quickFilter = $scope.selectedQuickFilter.filterType
    }

    return request
  }

  function LibrariesFilterRequestBuilderService() {
    var service = {
      getInstance: getInstance
    }

    return service

    /**
     * @description Factory method for creating a new instance of LibrariesFilterRequestBuilder
     * @param {object} $scope
     * @param {object} params
     * @param {function} params.selectedSubFilters
     * @returns {LibrariesFilterRequestBuilder}
     */
    function getInstance($scope, params) {
      return new LibrariesFilterRequestBuilder($scope, params)
    }
  }
})()
